module.exports = __webpack_public_path__ + "static/people_pop15-afed9e30cf9a164198ae9c5c3d4dd05e.png";